module.exports = __webpack_public_path__ + "static/media/shop-front-spraying-001.ba949f5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/shop-front-spraying-001.jpg
// module id = 93
// module chunks = 0